import { Text, TextProps } from "@chakra-ui/react";

const Error: React.FC<TextProps> = (props) => {
  return (
    <Text pl="3rem" mt="0.5rem" color="red" fontWeight={"bold"} {...props}>
      こちらのフィールドが未入力です。フィールドに入力してください。
    </Text>
  );
};

export default Error;
